import { keys } from "@/utils/object";

export interface IGetEvolutionMetricClassColorOpts {
  positiveClassColor: string;
  negativeClassColor: string;
}

export const defaultGetEvolutionMetricClassColorOpts: IGetEvolutionMetricClassColorOpts = {
  positiveClassColor: "text-red-500",
  negativeClassColor: "text-teal-500",
};

export function getValueClassColor(
  value: number | null | undefined,
  opts?: Partial<IGetEvolutionMetricClassColorOpts>,
) {
  const _opts = Object.assign({}, defaultGetEvolutionMetricClassColorOpts, opts);
  const { positiveClassColor, negativeClassColor } = _opts;

  if (!value) return;

  return value > 0 ? positiveClassColor : negativeClassColor;
}

export interface ISystemColor {
  backgroundColor: string;
  textColor: string;
  borderColor: string;
}

export type SystemColorName = "VIOLET" | "BLUE" | "EMERALD" | "AMBER" | "RED";

export const SYSTEM_COLORS_LIST: Record<SystemColorName, ISystemColor> = {
  ["VIOLET"]: {
    backgroundColor: "bg-violet-200/30",
    textColor: "text-violet-600",
    borderColor: "border-violet-200",
  },
  ["BLUE"]: {
    backgroundColor: "bg-blue-200/30",
    textColor: "text-blue-600",
    borderColor: "border-blue-200",
  },
  ["EMERALD"]: {
    backgroundColor: "bg-emerald-200/30",
    textColor: "text-emerald-600",
    borderColor: "border-emerald-200",
  },
  ["AMBER"]: {
    backgroundColor: "bg-amber-200/30",
    textColor: "text-amber-600",
    borderColor: "border-amber-200",
  },
  ["RED"]: {
    backgroundColor: "bg-red-200/30",
    textColor: "text-red-500",
    borderColor: "border-red-200",
  },
};

function stringToArrayItem<T>(str: string, array: T[]): T {
  let hash = 0;
  for (const char of str) {
    hash = (hash << 5) - hash + char.charCodeAt(0);
    hash |= 0; // Constrain to 32bit integer
  }

  return array[Math.abs(hash) % keys(SYSTEM_COLORS_LIST).length];
}

export function stringToSystemColour(str: string): ISystemColor {
  return stringToArrayItem(str, Object.values(SYSTEM_COLORS_LIST));
}

function* systemColorGeneratorFn() {
  while (true) yield* Object.values(SYSTEM_COLORS_LIST);
}

export const systemColorGenerator = systemColorGeneratorFn();
